export class TokenExpiredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  static isInstance(error: unknown): boolean {
    return error instanceof TokenExpiredError;
  }
}
